module.exports = __webpack_public_path__ + "media/images/athletes/83-048264ad993c5ad919396c36bcae1465.png";